<template>
    <div class="login-page">
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
            <div class="container">
                <div class="navbar-wrapper w-100">
                    <a class="navbar-brand w-100" href="https://www.bigscoots.com/" target="_blank">
                        <img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
                    </a>
                </div>
            </div>
        </nav>
        <!-- End Navbar -->
        <div class="wrapper wrapper-full-page ">
            <div class="full-page section-image">
                <div class="content">
                    <div class="container">
                        <div class="col-lg-5 col-md-6 ml-auto mr-auto">
                            <div class="card card-login" v-if="!asyncDone">
                                <div class="card-body">
                                    <!-- Show the loader when async operation is going on -->
                                    <div class="loader"></div>
                                </div>
                            </div>
                            <form class="form" @submit.prevent="createNewPassword" v-else>
                                <div class="card card-login">
                                    <div class="card-header ">
                                        <div class="card-header ">
                                            <h3 class="header text-center" style="margin-bottom: 0">
                                                Set your password for BigScoots WPO Account <br/>
                                                <small style="font-size: 65%">{{userEmail}}</small>
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="card-body ">
                                        <div class="form-group input-group mb-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="nc-icon nc-key-25"></i>
                                                </span>
                                            </div>
                                            <input type="password" required class="form-control" placeholder="New Password" v-model.trim="password">
                                        </div>
                                        <div class="form-group input-group mb-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="nc-icon nc-key-25"></i>
                                                </span>
                                            </div>
                                            <input type="password" required class="form-control" placeholder="Confirm New Password" v-model.trim="confirmPassword">
                                        </div>
                                        <p class="text-danger text-center mb-0" v-if="feedback !== ''"><strong>{{feedback }}</strong></p>
                                    </div>
                                    <div class="card-footer pt-0">
                                        <button type="submit" class="btn btn-warning btn-round btn-block mb-3" :disabled="password === '' || confirmPassword === ''">Set Password</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <footer class="footer footer-black  footer-white ">
                    <div class="container-fluid">
                        <div class="row">
                            <nav class="footer-nav">
                                <ul>
                                    <li>
                                        <a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
                                    </li>
                                </ul>
                            </nav>
                            <div class="credits ml-auto">
				<span class="copyright">
					©{{ currentYear }}, made with
					<i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>
				</span>
                            </div>
                        </div>
                    </div>
                </footer>
                <div class="full-page-background"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { auth, db } from "@/firebase/init";
    import swal from 'sweetalert2';
    export default {
        name: "ResetPassword",
        data() {
            return {
                password: '',
                confirmPassword: '',
                feedback: '',
                resetPasswordCode: '',
                userEmail: '',
                rules: [
                    { message:'One lowercase letter required.', regex:/[a-z]+/ },
                    { message:"One uppercase letter required.",  regex:/[A-Z]+/ },
                    { message:"8 characters minimum.", regex:/.{8,}/ },
                    { message:"One number required.", regex:/[0-9]+/ }
                ],
            }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear()
            },
            asyncDone() {
                return this.$store.getters["async/state"];
            }
        },
        async mounted() {
            document.body.classList.add('login-page')
            $('.form-control').on("focus", function () {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function () {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });
            this.$store.dispatch("async/stateUpdate", {state: false});
            this.resetPasswordCode = this.$route.query.oobCode;
            console.log(this.resetPasswordCode);
            if(!this.resetPasswordCode){
                return this.$router.push('/');
            }
            auth.verifyPasswordResetCode(this.resetPasswordCode).then((email) => {
                this.userEmail = email;
            }).catch((e) => {
                console.error(e);
                swal({
                    title: "Link Expired!",
                    text: 'Your password reset link has expired! Please enter your email address to generate a new link.',
                    type: "warning",
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showLoaderOnConfirm: true,
                    confirmButtonText: "Generate",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    cancelButtonColor: "#EE8057",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    preConfirm: (email) => {
                        return auth.sendPasswordResetEmail(email).then(() => {
                            return true;
                        }).catch(e => {
                            console.error(e);
                            swal.showValidationMessage(e)
                        });
                    },
                }).then(result => {
                    if(result.value) {
                        swal('Success!', 'New password reset link has been sent to your given email address', 'success');
                    }
                    this.$router.push('/');
                });
            }).finally(() => {
                this.$store.dispatch("async/stateUpdate", {state: true})
            });
        },
        methods: {
            passwordValidation () {
                let errors = [];
                let errorHtml = '<ul style="text-align: left">';
                for (let condition of this.rules) {
                    if (!condition.regex.test(this.password)) {
                        errors.push(condition.message);
                        errorHtml += '<li>'+condition.message+'</li>';
                    }
                }
                errorHtml += '</ul>';
                if (errors.length === 0) {
                    return { valid:true, errors, errorHtml }
                } else {
                    return { valid:false, errors, errorHtml }
                }
            },
            async createNewPassword() {
                if(this.password !== this.confirmPassword){
                    return swal('Error!', 'Your passwords do not match!', 'error');
                }
                const passwordValidation = this.passwordValidation();
                if(!passwordValidation.valid){

                    swal({
                        title: "Invalid Password",
                        html: '<span>Your password must be according to the following guidelines</span><br/>' + passwordValidation.errorHtml,
                        type: "error"
                    });
                    return;
                }
                this.$store.dispatch("async/stateUpdate", {state: false});
                auth.confirmPasswordReset(this.resetPasswordCode, this.password).then(async () => {
                    await auth.signInWithEmailAndPassword(this.userEmail, this.password);
                    await db.collection('users').doc(auth.currentUser.uid).update({
                        lastPasswordReset: new Date().toISOString()
                    });
                    this.getLoggedUser(auth.currentUser.uid);
                }).catch((e) => {
                    console.error(e);
                    this.$store.dispatch("async/stateUpdate", {state: true});
                    this.$swal('Error!', 'Error occurred during confirmation! Please try to reset the password again.', 'error');
                })
            },
            getLoggedUser(uid){
                console.log('Fetching User Info...');
                db.collection('users').doc(uid).get()
                    .then(doc => {
                        // Check if the document exists - then do more checks; Else throw error
                        if(doc.exists) {
                            const user = {
                                firstName: doc.data().firstName,
                                lastName: doc.data().lastName,
                                email: doc.data().email,
                                userType: doc.data().userType,
                                customerID: doc.data().customerID ? doc.data().customerID : null,
                                uid: doc.id,
                                notifications: doc.data().notifications ? doc.data().notifications : false,
                                muteNoti: (doc.data().muteNotiFlag !== undefined) ? doc.data().muteNotiFlag : true,
                                twoFA:doc.data().twoFA,
                                isEmailSetup: doc.data().emailSetupFlag
                            };

                            this.$store.dispatch('updateUserDetails', user);


                            if(!user.twoFA){
                                // Store the received data about the user in the Local Storage
                                localStorage.setItem('userDtls', JSON.stringify(user));
                                // Also dispatch the details to Vuex store
                                auth.currentUser.getIdToken().then((idToken)=>{
                                    this.$store.dispatch('updateUserDetails', {...user, idToken: idToken})
                                    localStorage.setItem('userDtls', JSON.stringify({...user, idToken: idToken}))
                                });

                                this.$store.dispatch("customer/allDetailsUpdate", {...doc.data(), uid: doc.id, docID: doc.id});

                                // set a cookie for 24hours if user does not have 2FA
                                this.$cookie.set('login-session', true, { expires: '24h' });


                                // Check what kind of a user is this by checking userType of the received data
                                // if userType === admin then redirect to admin page
                                if(user.userType === 'admin' || user.userType === 'manager' || user.userType === 'super-admin' ) {

                                    this.$router.push({ name: 'adminDashboard' });

                                } else {
                                    this.$router.push({ name: 'userDashboard' });

                                }
                                this.addLog({
                                    name: user.firstName + " " + user.lastName,
                                    message: "Logged in",
                                    level:  "info"
                                })
                            }else{
                                this.$router.push('/two-fa');
                            }
                        } else {
                            this.feedback = "No info available about this user in DB. SOL: DelUserManually"
                            this.$store.dispatch("async/stateUpdate", {state: true});
                            this.addLog({
                                name: "Problem with login user: " + this.email,
                                message: this.feedback,
                                level:  "danger"
                            })
                        }
                    })
                    .catch(err => {
                        this.$store.dispatch("async/stateUpdate", {state: true});

                        // Show error
                        this.feedback = err.message;
                        this.addLog({
                            name: "Anonymous",
                            message: err.message,
                            level:  "danger"
                        })
                    })
            }
        },
        beforeDestroy() {
            document.body.classList.remove('login-page')
        }
    }
</script>

<style scoped>

</style>
